import { Component, OnInit } from '@angular/core';
import { ApplicantAnalyticsModel } from './application-management.model';
import { ApplicantService } from './application-management.service';

@Component({
  selector: 'app-application-management',
  templateUrl: './application-management.component.html',
  styleUrls: ['./application-management.component.less'],
  providers: [ApplicantService],
})
export class ApplicationManagementComponent implements OnInit {
  applicantsAnalytics: ApplicantAnalyticsModel[];
  activeTab = 'pending';

  constructor(private _applicantService: ApplicantService) {}

  ngOnInit() {
    this.init();
  }

  init() {
    this._applicantService.getApplicantsAnalytics()
      .subscribe((response: ApplicantAnalyticsModel[]) => console.log(this.applicantsAnalytics = response));
  }

  changeTab(selected) {
    this.activeTab = selected;
  }

  updateListApplicants() {
    this.init();
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/application-management.component.ts